<div class="container-fluid glb-popup analytics-dialog">
  <p-toast [style]="{marginTop: '80px'}"></p-toast>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:0;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>

  <h2>Link Analytics</h2>
  <hr>

    @if (loading) {
      <div style="text-align:center; padding: 40px;">
        <i class="pi pi-spin pi-spinner" style="font-size: 2rem;"></i>
      </div>
    }

    @if (!loading && analytics) {
      <div>
        <!-- Link Info -->
        <div class="link-info-box">
          <div class="link-info-row">
            <span class="info-label">Destination</span>
            <a [href]="analytics.destinationUrl" target="_blank" class="info-url">{{analytics.destinationUrl}}</a>
          </div>
          <div class="link-info-row">
            <span class="info-label">Tracking URL</span>
            <span class="info-url monospace">{{analytics.trackingUrl}}</span>
            <i class="pi pi-copy copy-icon" (click)="copyTrackingUrl()" title="Copy"></i>
          </div>
          <div class="link-info-row">
            <span class="info-label">Source</span>
            <span>{{analytics.sourceType}}@if (analytics.sourceName) {
              <span> &mdash; {{analytics.sourceName}}</span>
            }</span>
          </div>
          <div class="link-info-row">
            <span class="info-label">Created</span>
            <span>{{analytics.createdAt | date:'medium'}}</span>
          </div>
          @if (trackedLink.msgId) {
            <div class="link-info-row">
              <span class="info-label">Message</span>
              <a class="la-msg-link" title="Open Message" (click)="openMessage(trackedLink.msgId)">
                Msg #{{trackedLink.msgId}}
                <i class="pi pi-external-link" style="font-size:9px; margin-left:3px;"></i>
              </a>
            </div>
          }
        </div>
        <!-- Stats Cards -->
        <div class="stats-row">
          <div class="stat-card stat-primary">
            <div class="stat-value">{{analytics.totalClicks || 0}}</div>
            <div class="stat-label">Total Clicks</div>
          </div>
          <div class="stat-card stat-secondary">
            <div class="stat-value">{{analytics.uniqueClicks || 0}}</div>
            <div class="stat-label">Unique Clicks</div>
          </div>
          <div class="stat-card">
            <div class="stat-value">{{analytics.lastClickedAt ? (analytics.lastClickedAt | date:'shortDate') : 'Never'}}</div>
            <div class="stat-label">Last Click</div>
          </div>
        </div>
        <!-- Device Breakdown -->
        @if (deviceEntries.length > 0) {
          <div class="section">
            <h3 class="section-title">Device Breakdown</h3>
            <div class="device-list">
              @for (d of deviceEntries; track d) {
                <div class="device-row">
                  <i [class]="getDeviceIcon(d.device)" style="width:20px; text-align:center; color:#666;"></i>
                  <span class="device-name">{{d.device}}</span>
                  <div class="device-bar-container">
                    <div class="device-bar" [ngStyle]="{'width': d.percent + '%'}"></div>
                  </div>
                  <span class="device-count">{{d.count}} ({{d.percent}}%)</span>
                </div>
              }
            </div>
          </div>
        }
        <!-- Daily Clicks -->
        @if (analytics.clicksByDay && analytics.clicksByDay.length > 0) {
          <div class="section">
            <h3 class="section-title">Clicks by Day</h3>
            <div class="daily-chart">
              @for (day of analytics.clicksByDay; track day) {
                <div class="daily-bar-row">
                  <span class="daily-date">{{day.date}}</span>
                  <div class="daily-bar-container">
                    <div class="daily-bar" [ngStyle]="{'width': (day.clicks / getMaxClicks() * 100) + '%'}"></div>
                  </div>
                  <span class="daily-count">{{day.clicks}}</span>
                </div>
              }
            </div>
          </div>
        }
        <!-- Top Referers -->
        @if (analytics.topReferers && analytics.topReferers.length > 0) {
          <div class="section">
            <h3 class="section-title">Top Referers</h3>
            <div class="referer-list">
              @for (ref of analytics.topReferers; track ref; let i = $index) {
                <div class="referer-item">
                  <span class="referer-rank">{{i + 1}}.</span>
                  <span class="referer-name">{{ref}}</span>
                </div>
              }
            </div>
          </div>
        }
        <!-- Recent Clicks Detail -->
        <div class="section">
          <h3 class="section-title">Recent Clicks</h3>
          @if (clicksLoading) {
            <div style="text-align:center; padding: 20px;">
              <i class="pi pi-spin pi-spinner"></i>
            </div>
          }
          @if (!clicksLoading) {
            <p-table [value]="clicks" styleClass="p-datatable-sm p-datatable-striped"
              [paginator]="false" [responsive]="true">
              <ng-template pTemplate="header">
                <tr>
                  <th>Time</th>
                  <th>Device</th>
                  <th>Referer</th>
                  <th>IP Hash</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-click>
                <tr>
                  <td>{{click.clickedAt | date:'short'}}</td>
                  <td>
                    <i [class]="getDeviceIcon(click.deviceType)" style="margin-right:4px;"></i>
                    {{click.deviceType}}
                  </td>
                  <td class="referer-cell">{{click.referer || 'direct'}}</td>
                  <td class="ip-cell">{{click.ipHash ? (click.ipHash | slice:0:12) + '...' : '-'}}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="4" style="text-align:center; padding: 20px; color: #999;">No click details recorded yet.</td>
                </tr>
              </ng-template>
            </p-table>
          }
        </div>
      </div>
    }
  </div>
